export const initialDeviceKVStoresState = {
    kvStoresByDeviceIdByKey: {},
    kvStoreKeysByDeviceId: {},
};
